import styled from 'styled-components';
import { ReactComponent as TagSVG } from 'Images/icon-action-bar-tags.svg';

export const TagIcon = styled(TagSVG)`
    height: 17px;
`;
TagIcon.displayName = 'Tag';

export default TagIcon;
